<template>
  <el-popover :placement="placement" :width="width" :trigger="trigger" popper-class="workorder-popover">
    <div class="pl pr text-black">
      <div class="flex">
        <div class="bd">
          <div class="text-muted">{{ workorderInfo.workorder_no }}</div>
          <div class="font-20">{{ workorderInfo.process_title }}</div>
        </div>
        <div class="ft pl-sm">
          <div class="pull-right font-16">{{ workorderInfo.station_title }}</div>
        </div>

      </div>
      <div class="pt pb process">
        <workorder-process :workorder-info="workorderInfo" />
      </div>
      <div class="pb pt">
        <div class="pt-sm flex" v-if="workorderInfo.mfg_no">
          <div class="d-title">制 号</div>：
          <div></div>
          {{ workorderInfo.mfg_no }}
        </div>
        <div class="pt-sm flex" v-if="workorderInfo.material_no">
          <div class="d-title">部 件</div>：
          <div></div>
          {{ workorderInfo.material_no + ' / ' + workorderInfo.material_title }}
        </div>
        <div class="pt-sm flex" v-if="workorderInfo.process_no">
          <div class="d-title">工 序</div>：
          <div></div>
          {{ workorderInfo.process_no + ' / ' + workorderInfo.process_title }}
        </div>
        <div class="pt-sm flex" v-if="workorderInfo.plan_num">
          <div class="d-title">数 量</div>：
          <div></div>
          <span class="tag mr-xs font-10">派工</span>
          {{ workorderInfo.plan_num }} 件
        </div>
        <div class="pt-sm flex" v-if="workorderInfo.standard_hour">
          <div class="d-title">工 时</div>：
          <div></div>
          <span class="tag mr-xs font-10">派工</span>
          {{ workorderInfo.standard_hour + ' ' + workorderInfo.standard_unit + ' /件' }}
          <span class="tag ml-xs mr-xs font-10" v-if="workorderInfo.add_hour">附加</span>
          <span v-if="workorderInfo.add_hour">{{ workorderInfo.add_hour + ' ' + workorderInfo.standard_unit }}</span>
        </div>

      </div>
    </div>

    <div slot="reference">
      <slot />
    </div>
  </el-popover>
</template>

<script>
import WorkorderProcess from './WorkorderProcess.vue'
export default {
  components: { WorkorderProcess },
  props: {
    workorderInfo: {
      type: Object,
      default: () => { return {} }
    },
    placement: {
      type: String,
      default: 'left-start'
    },
    width: {
      type: String,
      default: '400'
    },
    trigger: {
      type: String,
      default: 'click'
    }
  }
}
</script>

<style lang="scss" scoped>
.workorder-popover {
  .process {
    border-bottom: 1px solid #e0e3ea;
  }

  .tag {
    text-align: center;
    height: 20px;
    line-height: 20px;
    color: #997bec;
    padding: 0px 2px;
    border-radius: 2px;
    border: 1px solid #997bec;
  }

  .d-title {
    white-space: nowrap;
  }
}
</style>